<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增问题
      </a-button>
	  <a-select placeholder="请选择合作企业" v-model="company_id"  style="width: 225px; margin:19px 23px 0;float:right;border-radius: 15px;"  @change="value => onChangecompany(value)">
	  					<a-select-option v-for="item in companyData" :key="item.id" :value="item.id">
	  						{{ item.companyInfo.qichacha_name }}
	  					</a-select-option>
	  				</a-select>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <question-modal
      ref="formRef"
      :visible="visible"
      :title="title"
      :select-is-disabled="selectIsDisabled"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </question-modal>
  </div>
</template>
<script>
const uuidv1 = require('uuid/v1');
import { columns } from './data/index';
import { getType, getCompany } from './utils/dealTable';
import QuestionModal from './modal/index.vue';
export default {
  components: { QuestionModal },
  data() {
    return {
      selectData: [],
      columns,
      tableData: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      visible: false,
      title: '',
      questionId: undefined,
      btnIsLoading: false,
      selectIsDisabled: false,
	  company_id:null,
	  companyData: [],
    };
  },
  mounted() {
	this.getCompanyList();
    // 获取表格数据
    // this.getTableData({ page: this.current, pageSize: this.pageSize,company_id: this.company_id });
  },
  methods: {
	  onChangecompany(value) {
	    this.current=1;
	    this.company_id=value;
	    this.getTableData({ page: this.current, pageSize: this.pageSize,cooperation_company_id: this.company_id });
	  },
	  // 获取合作企业
	     async getCompanyList() {
	       let result = await this.$http.post('/Company/getCooperationCompanyList');
	       if (result.data.status === 1) {
          this.companyData = result.data.data.data_list;
          this.company_id=this.companyData[0].id
          this.getTableData({ page: this.current, pageSize: this.pageSize,cooperation_company_id: this.company_id });
	       }
	     },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/QuestionBank/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            question: item.question,
            type: item.type,
            data: item,
          };
          temp.push(obj);
        });
        this.tableData = temp;
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      console.log('TCL: editAndAdd -> record', record);
      this.visible = true;
      this.selectIsDisabled=false;
      if (!record.id) {

        // 新增
        this.questionId ='';
        this.title = '新增题目';
        this.$refs.formRef.initData();
        this.$nextTick(() => {
        this.$refs.formRef.form.resetFields();
        });
      } else {
        // 编辑
        this.selectIsDisabled=true;
        this.questionId = record.id;
        this.title = '编辑题目';
        let options={};
        let temp=record.data.options;
        console.log('editAndAdd -> temp', temp);
        if(temp){
          temp.forEach((item)=>{
            options[item.key]={value: item.value};
          });
        }else{
          options=undefined;
        }
        console.log('options', options);
        this.$refs.formRef.updateData(temp, String(record.data.type) );
        this.$nextTick(() => {
          let data = {
            type: String(record.data.type),
            question: record.data.question,
            ...options,
          };
          this.$refs.formRef.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.form.validateFields(
        async(err, values) => {
          console.log('TCL: onSubmit -> values', values);
          if (!err) {
            let value=[];
            Object.values(values).forEach((item, index)=>{
              if(typeof item ==='object'){
                value.push({...item, key: Object.keys(values)[index]});
              }
            });
            let data={
              options: value,
              type: values.type,
              question: values.question,
			  
            };
            this.btnIsLoading=true;
            let result = await this.$http.post('/QuestionBank/update', {
              ...data,
              id: this.questionId,
			        cooperation_company_id: this.company_id
            });
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.visible = false;
              this.getTableData({ page: this.current, pageSize: this.pageSize ,cooperation_company_id: this.company_id});
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/QuestionBank/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize,cooperation_company_id: this.company_id });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/QuestionBank/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize,cooperation_company_id: this.company_id });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: pagination.current,
        pageSize: pagination.pageSize,
        cooperation_company_id: this.company_id
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
/deep/.ant-select-selection--single{
  border-radius: 15px;
}
</style>
